import { Link } from 'react-router-dom';

const steps = [
  {
    step: '01',
    title: 'Initial Conversation',
    description:
      'Carol learns about your property, your goals and your ideal timeframe. No pressure — just a helpful discussion about where you are and where you would like to be.',
  },
  {
    step: '02',
    title: 'Property and Market Review',
    description:
      'Carol assesses your property and reviews relevant local market information, including recent sales, current listings and buyer demand in your area.',
  },
  {
    step: '03',
    title: 'Personal Selling Strategy',
    description:
      'You receive clear recommendations regarding pricing, preparation and marketing — all tailored to your property and your personal circumstances.',
  },
  {
    step: '04',
    title: 'Launch and Buyer Enquiries',
    description:
      'Your property is professionally presented, marketed across multiple channels and shown to prospective buyers, with Carol managing every enquiry.',
  },
  {
    step: '05',
    title: 'Offers, Negotiation and Closing',
    description:
      'Carol helps you review offers, negotiate suitable terms and guide the transaction through to a successful completion.',
  },
];

export default function SellingProcess() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-14">
          <p className="text-primary-500 font-body text-sm tracking-widest uppercase mb-3">
            The Process
          </p>
          <h2 className="font-heading text-foreground-900 text-2xl md:text-3xl lg:text-4xl mb-4">
            How the Selling Process Works
          </h2>
          <p className="text-foreground-600 font-body text-base max-w-[600px] mx-auto">
            Selling a home can feel complicated — but when you break it down, it
            follows a clear path. Here is how Carol guides you through each stage.
          </p>
        </div>

        <div className="relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute left-8 top-12 bottom-12 w-px bg-background-300" />

          <div className="flex flex-col gap-10">
            {steps.map((s, i) => (
              <div key={i} className="flex flex-col lg:flex-row gap-4 lg:gap-8 items-start">
                <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading text-xl font-bold">
                  {s.step}
                </div>
                <div className="flex-1 pt-1">
                  <h3 className="font-heading text-foreground-900 text-xl mb-2">
                    {s.title}
                  </h3>
                  <p className="text-foreground-600 font-body text-sm md:text-base leading-relaxed">
                    {s.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-8 py-3.5 rounded-md text-base font-body font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-200"
          >
            <i className="ri-chat-3-line text-lg" />
            Start With a Free Conversation
          </Link>
        </div>
      </div>
    </section>
  );
}